export default {
  'creativeImage.filter.status.all': 'All statuses',
  'creativeImage.filter.status.running': 'Generating',
  'creativeImage.filter.status.success': 'Succeeded',
  'creativeImage.filter.status.fail': 'Failed',
  'creativeImage.empty': 'No images yet',
  'creativeImage.loadFailed': 'Failed to load images',
  'creativeImage.loadingMore': 'Loading more…',
  'creativeImage.noMore': 'No more items',
  'creativeImage.download': 'Download',
  'creativeImage.recreate': 'Create again',
  'creativeImage.downloadFailed': 'Download failed',
  'creativeImage.delete': 'Delete',
  'creativeImage.deleteSuccess': 'Deleted successfully',
  'creativeImage.deleteFailed': 'Delete failed. Please try again.',
  'creativeImage.noPreview': 'No image available for preview',
  'creativeImage.copyPromptSuccess': 'Copied successfully',
  'creativeImage.copyPromptFailed': 'Copy failed',
  'creativeImage.meta.refImage': 'Reference image',
  'creativeImage.meta.refVideo': 'Reference video',
  'creativeImage.meta.firstFrame': 'First frame',
  'creativeImage.meta.lastFrame': 'Last frame',
};
